import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck, Zap } from 'lucide-react';
const CHECKOUT_URL = 'https://fitness-senior-pro.impultienda.ar/checkout';
const BOX_IMG = 'https://cdn.magicpatterns.com/uploads/3XUSYHUsLox53cS6HwHc5d/ChatGPT-Image-1-jul-2026_-09_08_36-p.m..webp';
export function FinalCTA() {
  return <section className="py-12 px-4 sm:px-6 bg-petrol text-white border-t-8 border-gold text-center" data-id="element-47">
      <p className="text-sm font-body font-bold text-gold uppercase tracking-widest mb-3" data-id="element-48">
        Un'Ultima Occasione
      </p>

      <div className="max-w-3xl mx-auto mb-8" data-id="element-49">
        <p className="text-lg sm:text-2xl font-subheading font-bold mb-5 leading-snug" data-id="element-50">
          I tuoi partecipanti meritano più di sessioni improvvisate.
        </p>

        <div className="text-base sm:text-lg text-ivory/90 leading-snug space-y-2 mb-5" data-id="element-51">
          <p data-id="element-52">Smetti di passare ore a pianificare.</p>
          <p data-id="element-53">Smetti di dubitare della struttura della tua lezione.</p>
          <p data-id="element-54">Smetti di preoccuparti di non offrire abbastanza progressione.</p>
          <p className="font-bold text-gold text-lg sm:text-xl mt-4" data-id="element-55">
            Dai ai tuoi partecipanti l'esperienza sicura, coinvolgente e
            professionale che meritano.
          </p>
        </div>
      </div>

      <div className="bg-petrol-dark border border-gold/30 rounded-xl p-5 mb-6 shadow-2xl max-w-md mx-auto" data-id="element-56">
        <p className="text-sm sm:text-base font-bold mb-2 uppercase tracking-widest text-ivory" data-id="element-57">
          🏋️ FITNESS SENIOR PRO™ — COFANETTO 6 IN 1 + 5 Bonus Premium
        </p>
        <p className="text-lg line-through text-ivory/50 mb-1" data-id="element-58">€97</p>
        <p className="text-4xl sm:text-5xl font-heading font-bold text-gold leading-none" data-id="element-59">
          Solo: €27 EUR
        </p>
      </div>

      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer mb-6" data-id="element-60">
        <img src={BOX_IMG} alt="FITNESS SENIOR PRO Cofanetto 6 in 1" className="w-full max-w-[240px] mx-auto object-contain drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-61" />
      </a>

      <div className="mb-5 max-w-lg mx-auto" data-id="element-62">
        <CTAButton href={CHECKOUT_URL} className="!bg-gold !text-petrol border-none shadow-[0_4px_14px_0_rgba(199,169,107,0.39)] hover:shadow-[0_6px_20px_rgba(199,169,107,0.23)] hover:!bg-gold/90" data-id="element-63">
          🚀 SÌ, VOGLIO IL MIO PACCHETTO FITNESS SENIOR PRO™
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm font-bold text-ivory/80" data-id="element-64">
        <div className="flex items-center gap-2" data-id="element-65">
          <Zap className="w-4 h-4 text-gold" data-id="element-66" />
          <span data-id="element-67">Accesso immediato — Consegnato via email</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-68">
          <Star className="w-4 h-4 fill-gold text-gold" data-id="element-69" />
          <span data-id="element-70">4.9/5 — Recensioni professionali verificate</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-71">
          <ShieldCheck className="w-4 h-4 text-sage" data-id="element-72" />
          <span data-id="element-73">Garanzia 7 giorni — Zero rischio</span>
        </div>
      </div>
    </section>;
}